/** Shared Level of Study dropdown options (student registration). */
export const PROGRAM_OPTIONS = [
  { value: 'undergraduate', label: 'Undergraduate Programs' },
  { value: 'graduate', label: 'Graduate Programs' },
  { value: 'phd', label: 'PhD Programs' },
  { value: 'scholarship', label: 'Scholarship Information' },
  { value: 'abroad', label: 'Study Abroad' },
  { value: 'other', label: 'Other' },
];

/** Level of Study options for lead form + edit lead. */
export const LEAD_PROGRAM_OPTIONS = [
  { value: 'undergraduate', label: 'Undergraduate' },
  { value: 'postgraduate', label: 'Postgraduate' },
];

/** Map legacy lead program values to the current lead options. */
export const normalizeLeadProgram = (value) => {
  if (!value) return '';
  const v = String(value).trim().toLowerCase();
  if (v === 'graduate' || v === 'graduate programs' || v === 'post graduate' || v === 'post-graduate') {
    return 'postgraduate';
  }
  if (v === 'undergraduate programs' || v === 'undergraduate') return 'undergraduate';
  if (v === 'postgraduate' || v === 'postgraduate programs') return 'postgraduate';
  return value;
};
